module.exports = "https://assets.calmac.co.uk/scripts/apps/site-services/1.9/img/selectArrow.svg";